import React, {
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";

import DialogoAutorizacaoComBiometria from '../DialogoAutorizacaoComBiometria'
import DialogoAutorizacaoComQrcode from '../DialogoAutorizacaoComQrcode'

const DialogoAutorizacao = forwardRef(
  (
    {
      handleSalvar,
      title,
      enqueueSnackbar,
      mensagemSucesso = "Item removido com sucesso!",
      hasTransportador = false,
      openConsultorPrecos = () => {},
      usar_biometria = false,
    },
    ref,
  ) => {

    const refDialogoAutorizacaoComBiometria = useRef(null);
    const refDialogoAutorizacaoComQrcode = useRef(null);

    useImperativeHandle(ref, () => ({
      handleOpen(codigoNew = 0, dados = null) {
        if(usar_biometria) {
          if(refDialogoAutorizacaoComBiometria.current) {
            refDialogoAutorizacaoComBiometria.current.handleOpen(codigoNew, dados, () => {
              if(refDialogoAutorizacaoComQrcode.current) {
                refDialogoAutorizacaoComQrcode.current.handleOpen(codigoNew, dados);
              }
            });
          }
        } else {
          if(refDialogoAutorizacaoComQrcode.current) {
            refDialogoAutorizacaoComQrcode.current.handleOpen(codigoNew, dados);
          }
        }
      },
    }));

    return (
      <>
        <DialogoAutorizacaoComBiometria
          ref={refDialogoAutorizacaoComBiometria}
          handleSalvar={handleSalvar}
          title={title}
          enqueueSnackbar={enqueueSnackbar}
          mensagemSucesso={mensagemSucesso}
          hasTransportador={hasTransportador}
          openConsultorPrecos={openConsultorPrecos}
        />

        <DialogoAutorizacaoComQrcode
          ref={refDialogoAutorizacaoComQrcode}
          handleSalvar={handleSalvar}
          title={title}
          enqueueSnackbar={enqueueSnackbar}
          mensagemSucesso={mensagemSucesso}
          hasTransportador={hasTransportador}
          openConsultorPrecos={openConsultorPrecos}
        />
      </>
    );
  },
);

export default DialogoAutorizacao;
